"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var checkLabels_exports = {};
__export(checkLabels_exports, {
  checkFormLabels: () => checkFormLabels
});
module.exports = __toCommonJS(checkLabels_exports);
var import_topo_core = require("@cartographerio/topo-core");
var import_lodash = require("lodash");
var import_guard = require("./guard.js");
var import_guard2 = require("@cartographerio/guard");
var import_util = require("@cartographerio/util");
function findDuplicates(strings) {
  const totals = strings.reduce(
    (acc, str) => ({
      ...acc,
      [str]: acc[str] ?? 0 + 1
    }),
    {}
  );
  return Object.entries(totals).filter(([_str, total]) => total > 1).map(([str]) => str);
}
function checkBlockLabels(pageNumber, block, lastHeading) {
  if ((0, import_guard.isField)(block)) {
    return lastHeading === block.label ? {
      messages: [
        (0, import_topo_core.errorMessage)(
          `Page ${pageNumber} has a field label following a heading with the same name: "${lastHeading}"`
        )
      ]
    } : { messages: [] };
  } else {
    switch (block.type) {
      case "Heading":
        return { messages: [], lastHeading: block.text };
      case "Card":
      case "FullWidth":
      case "RequireRole":
      case "Repeat":
      case "Scope":
      case "Visibility":
        return checkBlockLabels(pageNumber, block.block, lastHeading);
      case "Group":
        return checkBlocksLabels(pageNumber, block.blocks, lastHeading);
      case "Text":
      case "DynamicValue":
      case "DynamicImage":
      case "DynamicGrid":
      case "PrimarySurveyorField":
      case "PrimaryTeamField":
        return { messages: [], lastHeading };
      default:
        return (0, import_util.checkExhausted)(block);
    }
  }
}
function checkBlocksLabels(pageNumber, blocks, lastHeading) {
  return blocks.reduce(
    (acc, block) => {
      const output = checkBlockLabels(pageNumber, block, lastHeading);
      return {
        messages: acc.messages.concat(output.messages),
        lastHeading: output.lastHeading
      };
    },
    { messages: [] }
  );
}
function checkPageLabels(page, pageIndex) {
  const firstHeadingSame = page.blocks.length === 1 && page.blocks[0].type === "Heading" && page.blocks[0].text === page.title ? [(0, import_topo_core.errorMessage)(`Page ${pageIndex + 1} has a heading at the top with the same title as the page: ${page.title}`)] : [];
  return [...firstHeadingSame, ...checkBlocksLabels(pageIndex + 1, page.blocks).messages];
}
function checkFormLabels(form) {
  const singletonPageTitle = form.pages.length === 1 && form.pages[0].title != null && form.pages[0].title === form.title ? [(0, import_topo_core.errorMessage)(`Form has a single page with the same title as the form: ${form.title}`)] : [];
  const uniquePageTitles = findDuplicates(form.pages.map((page) => page.title).filter(import_guard2.isString)).map(
    (title) => (0, import_topo_core.errorMessage)(`Duplicate Page title: ${title}`)
  );
  const pages = (0, import_lodash.flatMap)(form.pages, (page, pageIndex) => checkPageLabels(page, pageIndex));
  return [...singletonPageTitle, ...uniquePageTitles, ...pages];
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  checkFormLabels
});
//# sourceMappingURL=checkLabels.js.map
